import { supportedCurrentProducts } from './supportedCurrentProducts';
import type { supportedProducts } from './supportedProducts';
/**
 * Product key returned by /available_sites data. We are only interested in
 * 'townsquare' (Atlas), 'confluence.ondemand' or 'jira-software.ondemand' currently.
 */
export type Product =
	| 'atlassian-whiteboard'
	| 'beacon'
	| 'compass'
	| 'confluence.ondemand'
	| 'hipchat.cloud'
	| 'jira-core.ondemand'
	| 'jira-incident-manager.ondemand'
	| 'jira-product-discovery'
	| 'jira-servicedesk.ondemand'
	| 'jira-software.ondemand'
	| 'mercury'
	| 'opsgenie'
	| 'statuspage'
	| 'townsquare'
	| 'loom';

/**
 * Products that we have config for that could be added as a tab
 */
export type SupportedProduct = (typeof supportedProducts)[number];

const suportedCurrentProductMap: {
	[K in string]: SupportedCurrentProduct | undefined;
} = {
	'jira-core.ondemand': 'jira',
	'jira-incident-manager.ondemand': 'jira',
	'jira-product-discovery': 'jira',
	'jira-servicedesk.ondemand': 'jira',
	'jira-software.ondemand': 'jira',
	'confluence.ondemand': 'confluence',
	townsquare: 'atlas',
	loom: 'loom',
};

/**
 * Possible values for the current product. This is currently typed in LinkPickerPluginsConfiguration as `string` so this is
 * used for checking tab order.
 */
export type SupportedCurrentProduct = (typeof supportedCurrentProducts)[number];

/**
 * Array of product keys returned by /available_sites data.
 * We are only interested in 'townsquare' (Atlas), 'confluence' or 'jira-software.ondemand' currently.
 */
export type AvailableProducts = Product[];
export interface Site {
	cloudId: string;
	products: AvailableProducts;
}
export type AvailableSitesResponse = {
	sites: Site[];
};

export function isSupportedCurrentProduct(
	str: string,
): str is (typeof supportedCurrentProducts)[number] {
	const strings: Readonly<string[]> = supportedCurrentProducts;
	return strings.includes(str);
}

/**
 * Given a product string (in the format fo the available-sites endpoint), find a
 * corresponding supported current product (if one existss)
 */
export function lookupCurrentProductByProduct(
	product: Product,
): SupportedCurrentProduct | undefined {
	// Product may not be in supportedProducts array, that's what this is checking
	if (!(product in suportedCurrentProductMap)) {
		return undefined;
	}
	return suportedCurrentProductMap[product];
}
